export const palette = {
  general: {
    white: '#ffffff',
    black: '#000000',
    cta: '#1B31A8',
    ctaHover: '#6071cc',
    darkBlue: '#1C1E1F',
    blue: '#0079FF',
    darkGray: '#F4F8FA',
    mediumGray: '#657786',
    lightGray: '#E1E8ED',
    boxShadow: 'rgba(150, 164, 176, 0.1)',
  },
};
